import { objectSelector } from 'theme/utils';
import {
  FETCH_STORES_PENDING,
  FETCH_STORES_REJECTED,
  FETCH_STORES_FULFILLED,
  AUTH_PENDING,
  AUTH_REJECTED,
  FETCH_STAFFS_PENDING,
  FETCH_STAFFS_FULFILLED,
  ACTIVATE_STAFF_REJECTED,
  ACTIVATE_STAFF_FULFILLED,
} from '../constants/auth';

const initialState = {
  stores: [],
  staffs: [],
  staffPage: false,
  pending: true,
  authPending: false,
  error: {},
  redirect: false,
};

export const auth = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STORES_PENDING:
      return initialState;

    case FETCH_STORES_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_STORES_FULFILLED:
      const storesKeys = Object.keys(action.response);
      let storesArray = storesKeys.map((el) => {
        return action.response[el];
      });
      return {
        ...state,
        pending: false,
        stores: [...storesArray],
        error: {},
      };

    case AUTH_PENDING:
      return {
        ...state,
        authPending: true,
        error: {},
      };

    case AUTH_REJECTED:
      const error = action.error.response.data.error;
      return {
        ...state,
        authPending: false,
        error: {
          password: error.non_field_errors && error.non_field_errors[0],
        },
      };

    case FETCH_STAFFS_PENDING:
      return {
        ...state,
        pending: true,
        staffPage: true,
        error: {},
      };

    case FETCH_STAFFS_FULFILLED:
      const staffsKeys = Object.keys(action.response);
      let staffsArray = staffsKeys.map((el) => {
        return action.response[el];
      });
      return {
        ...state,
        pending: false,
        staffPage: true,
        staffs: [...staffsArray],
        error: {},
      };

    case ACTIVATE_STAFF_REJECTED:
      const error_staff = objectSelector(action, 'error.response.data.error.detail');
      return {
        ...state,
        pending: false,
        error: {
          staff: error_staff
        },
      };

    case ACTIVATE_STAFF_FULFILLED:
      return {
        ...state,
        pending: false,
        redirect: true,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js